import {ComponentProps, FC} from 'react';

type IconProps = ComponentProps<'svg'> & {
    size?: number;
};

export const IconAiSparkles: FC<IconProps> = ({
    size = 32,
    width = size,
    height = size,
    fill = 'var(--color-icon-ai)',
    ...rest
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 32 32"
            fill="none"
            {...rest}
        >
            <path
                d="M14.8614 12.6674L12.7414 8.0007C12.2747 6.9607 10.7814 6.9607 10.3147 8.0007L8.19472 12.6674L3.52805 14.7874C2.48805 15.2674 2.48805 16.7474 3.52805 17.214L8.19472 19.334L10.3147 24.0007C10.7947 25.0407 12.2747 25.0407 12.7414 24.0007L14.8614 19.334L19.5281 17.214C20.5681 16.734 20.5681 15.254 19.5281 14.7874L14.8614 12.6674Z"
                fill={fill}
            />
            <path
                d="M26.5274 8.33401L25.474 10.6673C25.234 11.1874 24.4874 11.1874 24.2474 10.6673L23.194 8.32068L20.8607 7.26735C20.3407 7.02735 20.3407 6.29401 20.8607 6.05401L23.2074 5.00068L24.2607 2.66734C24.5007 2.14734 25.234 2.14734 25.474 2.66734L26.5274 5.01401L28.8607 6.06735C29.3807 6.30735 29.3807 7.04068 28.8607 7.28068L26.5274 8.33401Z"
                fill={fill}
            />
            <path
                d="M23.194 23.6667L24.2474 21.3334C24.4874 20.8134 25.234 20.8134 25.474 21.3334L26.5274 23.68L28.8607 24.7334C29.3807 24.9734 29.3807 25.7067 28.8607 25.9467L26.514 27L25.4607 29.3334C25.2207 29.8534 24.4874 29.8534 24.2474 29.3334L23.194 26.9867L20.8607 25.9334C20.3407 25.6934 20.3407 24.96 20.8607 24.72L23.194 23.6667Z"
                fill={fill}
            />
        </svg>
    );
};
